import { Toaster } from "react-hot-toast";
import "react-tooltip/dist/react-tooltip.css";
import "./App.css";
import Aos from "aos";
import "aos/dist/aos.css";
import Background from "./components/Background";
import { BlockchainProvider } from "./web3/BlockchainProvider";
import { DialogProvider } from "./providers/DialogProvider";
import { PlayerDataProvider } from "./providers/PlayerDataProvider";
import PageRouter from "./components/PageRouter";
import { SentryUtils } from "./utils/SentryUtils";
import { Tooltip } from "react-tooltip";

function App() {
  SentryUtils.init();

  Aos.init({
    delay: 0,
    duration: 1000,
    easing: "ease-in-out",
    once: true,
  });

  return (
    <BlockchainProvider>
      <DialogProvider>
        <PlayerDataProvider>
          <Tooltip id="default-tooltip" className="~max-w-80/96 z-100"/>
          <Background />
          <PageRouter />
          <Toaster />
        </PlayerDataProvider>
      </DialogProvider>
    </BlockchainProvider>
  );
}

export default App;
